import React from 'react'
import '../../App.css'
import './Insights.css'
import BackgroundSection from '../BackgroundSection'
import ContainerSection from '../ContainerSection'
import { Title } from '../Title'
import Trends from '../../images/trends.jpg'

export const Insights = () => {
  return (
    <>
      <BackgroundSection
        className='background'
        backgroundStyle='background--sixth'
      >
        Insights
      </BackgroundSection>

      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        {' '}
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          5 Global Trends Catalyzing Digital Transformation in Agriculture
        </Title>
        <div className='trends-pic-container'>
          <img className='trends' src={Trends} alt='Future Trends' />
        </div>
        <div className='trends-text-container'>
          <p className='trends-text'>
            <strong className='trends-bold-text'>
              Rising population and resulting increase in food demand.
            </strong>{' '}
            According to a{' '}
            <strong className='trends-color-text'>UN FAO report</strong>, the
            world population is expected to rise to 10 billion by 2050 and boost
            agricultural demand by 50 percent compared to 2013, with an increase
            in demand for proteins, fruits, and vegatables.
          </p>
          <br />
          <p className='trends-text'>
            <strong className='trends-bold-text'>
              Declines in farm income.
            </strong>{' '}
            Farm profits are at a{' '}
            <strong className='trends-color-text'>record 12-year low</strong>.
            In the first forecast of 2018, the US Department of Agriculture
            (USDA) is predicting farm profits to dwindle 6.7 percent to $59.5
            billion, which is the lowest it's been since 2006.
          </p>
          <br />
          <p className='trends-text'>
            <strong className='trends-bold-text'>
              Digital native consumers.
            </strong>{' '}
            There is a rising generation of digital-native, tech-savvy customers
            who come with expectations based on their experience in other
            digital-first industries. Meanwhile, consumer tastes and behaviors
            are evolving, with millennial customers driving demand for organic
            products, sustainable retail supply chains, and zero deforestation
            commitments.
          </p>
          <br />
          <p className='trends-text'>
            <strong className='trends-bold-text'>
              Digital disruption and consolidation.
            </strong>{' '}
            Agriculture input retailers are facing pressure from increasing
            consolidation in the seed and crop protection industry and from
            chaging demands from digitally native customers. Traders lack
            foresight into the crop volume and face highly volatile prices. And{' '}
            <strong className='trends-color-text'>digitization</strong> across
            the value chain and expansion of in-house storage among farmers is{' '}
            <strong className='trends-color-text'>
              disrupting their fundamental business model.
            </strong>
          </p>
          <br />
          <p className='trends-text'>
            <strong className='trends-bold-text'>Food loss and waste.</strong>{' '}
            According to <strong className='trends-color-text'>UN FAO</strong>,
            about one-third of all food produced - approximately 1.3 billion
            metric tons - get lost or wasted, while 795 million people go
            hungry. Every year, consumers in rich countries waste almost as much
            food (222 million metric tons) as the entire net food production of
            sub-Saharan Africa (230 million metric tons). Moreover, developing
            countries deal with a lack of cold chain infrastructure to transport
            fruits, vegetables and meat over long distances.
          </p>
          <br />
        </div>
        <div className='blue-trends-container'>
          <ol className='blue-trends-list'>
            <li className='blue-trends-item'>Population</li>
            <li className='blue-trends-item'>Declining farm incomes</li>
            <li className='blue-trends-item'>Sustainability/Transparency</li>
            <li className='blue-trends-item'>
              Agricultural Technology/Innovation
            </li>
            <li className='blue-trends-item'>Food loss and waste</li>
          </ol>
        </div>
      </ContainerSection>

      <ContainerSection
        className='container'
        containerStyle='container--contwo'
      >
        {' '}
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          4 Major Tech Trends Shaping the 4th Agriculture Revolution
        </Title>
        <div className='trends-text-container'>
          <p className='trends-text'>
            <strong className='trends-bold-text'>Farm Robotics.</strong>{' '}
            Robotics are getting better and better, and their viability is being
            explored across the agricultural value chain, from planting to
            harvesting, to meat processing and grocery logistics.{' '}
            <strong className='trends-color-text'>
              John Deere spent $305 million
            </strong>{' '}
            last year to acquire Blue River technology, a startup that makes
            robots capable of identifying unwanted plants and spraying them with{' '}
            <strong className='trends-color-text'>
              high-precision herbicide
            </strong>
            , reducing input costs and increasing efficiency. There is also new
            demand for{' '}
            <strong className='trends-color-text'>robotics as a service</strong>
            , especially when it comes to fruit picking. By 2024, robots are
            forecast to navigate the farm to the tune of an{' '}
            <strong className='trends-color-text'>
              estimated $5.7 billion agbot industry,
            </strong>{' '}
            five times the market size in 2016.
          </p>
          <br />
          <p className='trends-text'>
            <strong className='trends-bold-text'>Remote Sensing.</strong> A
            myriad of remote sensing techniques, from in-field sensors to drones
            to satellite imagery, are allowing farmers to view their crops from
            multiple perspectives. With advances in computing and sensor
            technology, farmers can now get access to high-cadence, broad area
            coverage with field-level detail. All these provide farmers
            up-to-date information in real-time, so changes can be made
            accordingly to their crops.
          </p>
          <br />
          <p className='trends-text'>
            <strong className='trends-bold-text'>
              Machine Learning and Analytics.
            </strong>{' '}
            Machine Learning and advanced analytics are being used to mine data
            for trends in every sectors, and agriculture is no exception. These
            can be applied before seed planting with plant breeders. Machine
            Learning can predict which traits and genes will be best for crop
            production, giving farmers the best breed for their location and
            climate. At the field level, machine learning techniques that use
            satellite data to{' '}
            <strong className='trends-color-text'>
              distinguish between crops
            </strong>
            , like corn and soy, providing valuable information for crop
            insurance, logistics, and commodity markets. The intersection of
            robotics and data from an increasingly connected farm will
            accelerate this trned even further.
          </p>
          <br />
          <p className='trends-text'>
            <strong className='trends-bold-text'>Blockchain.</strong> Earlier
            this year, one of the world's largest commodity traders,{' '}
            <strong className='trends-color-text'>Louis Dreyfus</strong> (LDC)
            joined forces with ING, ABN Amro, and Societe Generale to complete
            the agricultural sector's first blockchain commodity transaction.
            The prototype was used to execute a soybean shipment transaction
            from the United States to China. Featuring no paper contracts,
            certificates, or manual checks, the soybean shipment transaction
            from seller <strong className='trends-color-text'>LDC</strong> to
            Chinese buyer{' '}
            <strong className='trends-color-text' Shandong Bohi></strong> was
            completed at five times the speed of a paper-based trade using ING's
            blockchain prototype, increasing transparency, traceability and
            efficiency along the supply chain.
          </p>
          <br />
        </div>
        <div className='blue-trends-container'>
          <ol className='blue-trends-list'>
            <li className='blue-trends-item'>Farm Robotics</li>
            <li className='blue-trends-item'>Remote Sensing</li>
            <li className='blue-trends-item'>Machine Learning and Analytics</li>
            <li className='blue-trends-item'>Blockchain</li>
          </ol>
        </div>
      </ContainerSection>
    </>
  )
}
